<div class="real-assist" [ngClass]="variant">
  <!-- Chat variant: 3-layer nested structure for border effect -->
  <div
    class="real-assist-border"
    *ngIf="variant === 'chat'"
    (click)="openModal()"
  >
    <div class="real-assist-inner">
      <div class="real-assist-header">
        <div class="real-assist-icon">
          <app-icon name="real-assist-robot" size="100%"></app-icon>
        </div>
        <div class="real-assist-title-container">
          <div class="real-assist-title-row">
            <span class="real-assist-title">RealAssist</span>
            <span class="real-assist-badge">NEW</span>
          </div>
          <span class="real-assist-subtitle">YOUR HOA AI CONCIERGE</span>
        </div>
      </div>

      <div class="real-assist-input-container collapsed" *ngIf="!isModalOpen">
        <div class="real-assist-input-wrapper">
          <input
            type="text"
            class="real-assist-input"
            [placeholder]="placeholder"
            (focus)="openModal()"
            readonly
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Widget variant: Header section with 3-layer border effect -->
  <div class="real-assist-header-wrapper" *ngIf="variant === 'widget'">
    <div class="real-assist-border">
      <div class="real-assist-inner">
        <div class="real-assist-header">
          <div class="real-assist-icon">
            <app-icon name="real-assist-robot" size="100%"></app-icon>
          </div>
          <div class="real-assist-title-container">
            <div class="real-assist-title-row">
              <span class="real-assist-title">RealAssist</span>
              <span class="real-assist-badge">NEW</span>
            </div>
            <span class="real-assist-subtitle">YOUR HOA AI CONCIERGE</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Chat container (white box) - shown for widget variant (inline) -->
  <div class="real-assist-chat-container" *ngIf="variant === 'widget'">
    <!-- Chat conversation area (shown when chat has started) -->
    <div class="real-assist-chat" *ngIf="chatStarted" #messagesContainer>
      <!-- Messages -->
      <div
        *ngFor="let message of messages"
        class="chat-message"
        [ngClass]="message.type"
      >
        <div class="message-content">
          <div class="message-header" *ngIf="message.type === 'assistant'">
            <div class="message-header-left">
              <div class="message-avatar">
                <app-icon name="real-assist-robot" size="24px"></app-icon>
              </div>
              <span class="message-sender">RealAssist</span>
            </div>
            <!-- Feedback icons (not shown for greeting message) -->
            <div
              class="message-feedback"
              *ngIf="
                !message.isGreeting &&
                !message.isStreaming &&
                message.responseId
              "
            >
              <button
                *ngIf="
                  !message.feedbackGiven || message.feedbackGiven === 'positive'
                "
                type="button"
                class="feedback-btn"
                [class.active]="message.feedbackGiven === 'positive'"
                (click)="onThumbsUp(message)"
                aria-label="Thumbs up"
              >
                <app-icon
                  [name]="
                    message.feedbackGiven === 'positive'
                      ? 'thumbsup-filled'
                      : 'thumbsup'
                  "
                  size="24px"
                  [fill]="
                    message.feedbackGiven === 'positive'
                      ? feedbackIconColor
                      : undefined
                  "
                ></app-icon>
              </button>
              <button
                *ngIf="
                  !message.feedbackGiven || message.feedbackGiven === 'negative'
                "
                type="button"
                class="feedback-btn"
                [class.active]="message.feedbackGiven === 'negative'"
                (click)="onThumbsDown(message)"
                aria-label="Thumbs down"
              >
                <app-icon
                  [name]="
                    message.feedbackGiven === 'negative'
                      ? 'thumbsdown-filled'
                      : 'thumbsdown'
                  "
                  size="24px"
                  [fill]="
                    message.feedbackGiven === 'negative'
                      ? feedbackIconColor
                      : undefined
                  "
                ></app-icon>
              </button>
              <button
                type="button"
                class="feedback-btn"
                [class.copied]="copiedMessageId === message.id"
                (click)="onCopyMessage(message)"
                aria-label="Copy message"
              >
                <app-icon
                  [name]="copiedMessageId === message.id ? 'checkmark' : 'copy'"
                  size="24px"
                ></app-icon>
              </button>
            </div>
          </div>
          <div class="message-bubble">
            <span [innerHTML]="message.content | markdown"></span>
          </div>

          <!-- Action buttons (shown after streaming completes) -->
          <div
            class="message-actions"
            *ngIf="
              message.type === 'assistant' &&
              message.actionButtons &&
              !message.isStreaming
            "
          >
            <button
              *ngFor="let button of message.actionButtons"
              class="action-button"
              (click)="onActionButtonClick(button)"
              type="button"
            >
              {{ button.label }}
            </button>
          </div>

          <!-- Timestamp -->
          <div class="message-timestamp">
            {{ formatTime(message.timestamp) }}
          </div>
        </div>
      </div>

      <!-- Typing indicator -->
      <div class="chat-message assistant" *ngIf="isTyping">
        <div class="message-content">
          <div class="message-header">
            <div class="message-header-left">
              <div class="message-avatar">
                <app-icon name="real-assist-robot" size="24px"></app-icon>
              </div>
              <span class="message-sender">RealAssist</span>
            </div>
          </div>
          <div class="typing-indicator">
            <app-icon name="dot" size="8px"></app-icon>
            <app-icon name="dot" size="8px"></app-icon>
            <app-icon name="dot" size="8px"></app-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- Suggested questions (shown when chat not started) -->
    <div class="real-assist-questions" *ngIf="!chatStarted">
      <div class="real-assist-greeting">
        Hi 👋 I'm here to help with your HOA or portal needs. What can I do for
        you today?
      </div>
      <div class="real-assist-suggestions">
        <button
          *ngFor="let question of suggestedQuestions"
          class="real-assist-suggestion"
          (click)="onSuggestedQuestionClick(question)"
          type="button"
        >
          <app-icon
            name="sparkles"
            size="20px"
            class="suggestion-icon"
          ></app-icon>
          {{ question.text }}
        </button>
      </div>
    </div>

    <!-- Input section -->
    <div class="real-assist-input-container">
      <div
        class="real-assist-input-wrapper"
        [class.has-value]="inputValue.trim()"
      >
        <textarea
          class="real-assist-input"
          [placeholder]="placeholder"
          [(ngModel)]="inputValue"
          (keydown)="onInputKeydown($event)"
          (input)="autoResizeTextarea($event)"
          [disabled]="isTyping"
          rows="3"
          #widgetInput
        ></textarea>
        <button
          class="real-assist-send-button"
          (click)="onSubmit()"
          [disabled]="!inputValue.trim() || isTyping"
          type="button"
          aria-label="Send message"
        >
          <app-icon
            name="send"
            width="40px"
            height="40px"
            [fill]="inputValue.trim() ? '#FF7350' : '#EEEEEE'"
          ></app-icon>
        </button>
      </div>
    </div>

    <!-- Footer (inside chat container for widget) -->
    <div class="real-assist-footer">
      <span>RealAssist is powered by RealManage.</span>
      <a
        href="#"
        class="real-assist-learn-more"
        (click)="openDisclaimerModal($event)"
      >
        Learn More
      </a>
    </div>
  </div>
</div>

<!-- Modal overlay (chat variant only) -->
<div
  class="real-assist-modal-overlay"
  *ngIf="isModalOpen"
  #modalOverlay
  (click)="closeModal()"
>
  <div class="real-assist-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="real-assist-modal-header">
      <button
        class="real-assist-modal-close"
        (click)="closeModal()"
        type="button"
        aria-label="Close modal"
      >
        <app-icon name="close" size="24px"></app-icon>
      </button>
      <div class="real-assist-border">
        <div class="real-assist-inner">
          <div class="real-assist-header">
            <div class="real-assist-icon">
              <app-icon name="real-assist-robot" size="100%"></app-icon>
            </div>
            <div class="real-assist-title-container">
              <div class="real-assist-title-row">
                <span class="real-assist-title">RealAssist</span>
                <span class="real-assist-badge">NEW</span>
              </div>
              <span class="real-assist-subtitle">YOUR HOA AI CONCIERGE</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Content -->
    <div class="real-assist-modal-content" #modalMessagesContainer>
      <!-- Chat conversation area -->
      <div class="real-assist-chat" *ngIf="chatStarted">
        <!-- Messages -->
        <div
          *ngFor="let message of messages"
          class="chat-message"
          [ngClass]="message.type"
        >
          <div class="message-content">
            <div class="message-header" *ngIf="message.type === 'assistant'">
              <div class="message-header-left">
                <div class="message-avatar">
                  <app-icon name="real-assist-robot" size="24px"></app-icon>
                </div>
                <span class="message-sender">RealAssist</span>
              </div>
              <!-- Feedback icons (not shown for greeting message) -->
              <div
                class="message-feedback"
                *ngIf="
                  !message.isGreeting &&
                  !message.isStreaming &&
                  message.responseId
                "
              >
                <button
                  *ngIf="
                    !message.feedbackGiven ||
                    message.feedbackGiven === 'positive'
                  "
                  type="button"
                  class="feedback-btn"
                  [class.active]="message.feedbackGiven === 'positive'"
                  (click)="onThumbsUp(message)"
                  aria-label="Thumbs up"
                >
                  <app-icon
                    [name]="
                      message.feedbackGiven === 'positive'
                        ? 'thumbsup-filled'
                        : 'thumbsup'
                    "
                    size="24px"
                    [fill]="
                      message.feedbackGiven === 'positive'
                        ? feedbackIconColor
                        : undefined
                    "
                  ></app-icon>
                </button>
                <button
                  *ngIf="
                    !message.feedbackGiven ||
                    message.feedbackGiven === 'negative'
                  "
                  type="button"
                  class="feedback-btn"
                  [class.active]="message.feedbackGiven === 'negative'"
                  (click)="onThumbsDown(message)"
                  aria-label="Thumbs down"
                >
                  <app-icon
                    [name]="
                      message.feedbackGiven === 'negative'
                        ? 'thumbsdown-filled'
                        : 'thumbsdown'
                    "
                    size="24px"
                    [fill]="
                      message.feedbackGiven === 'negative'
                        ? feedbackIconColor
                        : undefined
                    "
                  ></app-icon>
                </button>
                <button
                  type="button"
                  class="feedback-btn"
                  [class.copied]="copiedMessageId === message.id"
                  (click)="onCopyMessage(message)"
                  aria-label="Copy message"
                >
                  <app-icon
                    [name]="
                      copiedMessageId === message.id ? 'checkmark' : 'copy'
                    "
                    size="24px"
                  ></app-icon>
                </button>
              </div>
            </div>
            <div class="message-bubble">
              <span [innerHTML]="message.content | markdown"></span>
            </div>

            <div
              class="message-actions"
              *ngIf="
                message.type === 'assistant' &&
                message.actionButtons &&
                !message.isStreaming
              "
            >
              <button
                *ngFor="let button of message.actionButtons"
                class="action-button"
                (click)="onActionButtonClick(button)"
                type="button"
              >
                {{ button.label }}
              </button>
            </div>

            <!-- Timestamp -->
            <div class="message-timestamp">
              {{ formatTime(message.timestamp) }}
            </div>
          </div>
        </div>

        <!-- Typing indicator -->
        <div class="chat-message assistant" *ngIf="isTyping">
          <div class="message-content">
            <div class="message-header">
              <div class="message-header-left">
                <div class="message-avatar">
                  <app-icon name="real-assist-robot" size="24px"></app-icon>
                </div>
                <span class="message-sender">RealAssist</span>
              </div>
            </div>
            <div class="typing-indicator">
              <app-icon name="dot" size="8px"></app-icon>
              <app-icon name="dot" size="8px"></app-icon>
              <app-icon name="dot" size="8px"></app-icon>
            </div>
          </div>
        </div>
      </div>

      <!-- Suggested questions -->
      <div class="real-assist-questions" *ngIf="!chatStarted">
        <div class="real-assist-greeting">
          Hi 👋 I'm here to help with your HOA or portal needs. What can I do
          for you today?
        </div>
        <div class="real-assist-suggestions">
          <button
            *ngFor="let question of suggestedQuestions"
            class="real-assist-suggestion"
            (click)="onSuggestedQuestionClick(question)"
            type="button"
          >
            <app-icon
              name="sparkles"
              size="20px"
              class="suggestion-icon"
            ></app-icon>
            {{ question.text }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Input -->
    <div class="real-assist-modal-input">
      <div
        class="real-assist-input-wrapper"
        [class.has-value]="inputValue.trim()"
      >
        <textarea
          class="real-assist-input"
          [placeholder]="placeholder"
          [(ngModel)]="inputValue"
          (keydown)="onInputKeydown($event)"
          (input)="autoResizeTextarea($event)"
          [disabled]="isTyping"
          rows="3"
          #modalInput
        ></textarea>
        <button
          class="real-assist-send-button"
          (click)="onSubmit()"
          [disabled]="!inputValue.trim() || isTyping"
          type="button"
          aria-label="Send message"
        >
          <app-icon
            name="send"
            width="40px"
            height="40px"
            [fill]="inputValue.trim() ? '#FF7350' : '#EEEEEE'"
          ></app-icon>
        </button>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="real-assist-modal-footer">
      <span>RealAssist is powered by RealManage.</span>
      <a
        href="#"
        class="real-assist-learn-more"
        (click)="openDisclaimerModal($event)"
      >
        Learn More
      </a>
    </div>
  </div>
</div>

<!-- Feedback Modal -->
<div
  class="feedback-modal-overlay"
  *ngIf="isFeedbackModalOpen"
  (click)="closeFeedbackModal()"
>
  <div class="feedback-modal" (click)="$event.stopPropagation()">
    <div class="feedback-modal-header">
      <h3 class="feedback-modal-title">Help us improve</h3>
      <button
        class="feedback-modal-close"
        (click)="closeFeedbackModal()"
        type="button"
        aria-label="Close feedback modal"
      >
        <app-icon name="close" size="20px"></app-icon>
      </button>
    </div>
    <div class="feedback-modal-content">
      <p class="feedback-modal-description">
        What went wrong with this response? Your feedback helps us improve
        RealAssist.
      </p>
      <textarea
        class="feedback-textarea"
        [class.error]="feedbackValidationError"
        [(ngModel)]="feedbackComment"
        placeholder="Tell us what could be better..."
        rows="4"
        (input)="feedbackValidationError = false"
      ></textarea>
      <span class="feedback-error-message" *ngIf="feedbackValidationError">
        This field is required
      </span>
    </div>
    <div class="feedback-modal-actions">
      <button
        class="feedback-btn-cancel"
        (click)="closeFeedbackModal()"
        type="button"
      >
        Cancel
      </button>
      <button
        class="feedback-btn-submit"
        (click)="submitFeedback()"
        type="button"
      >
        Submit Feedback
      </button>
    </div>
  </div>
</div>

<!-- Disclaimer Modal -->
<div
  class="disclaimer-modal-overlay"
  *ngIf="isDisclaimerModalOpen"
  (click)="closeDisclaimerModal()"
>
  <div class="disclaimer-modal" (click)="$event.stopPropagation()">
    <div class="disclaimer-modal-header">
      <h3 class="disclaimer-modal-title">AI-Powered Assistant Disclaimer</h3>
      <button
        class="disclaimer-modal-close"
        (click)="closeDisclaimerModal()"
        type="button"
        aria-label="Close disclaimer modal"
      >
        <app-icon name="close" size="20px"></app-icon>
      </button>
    </div>
    <div class="disclaimer-modal-content">
      <p>
        This chatbot provides automated responses for general informational
        purposes only and does not replace communication with property
        management. Responses may be incorrect or incomplete and should not be
        relied upon for legal, financial, or emergency matters. For official or
        account-specific assistance, please contact your management team
        directly.
      </p>
      <p>
        Conversations may be monitored and stored for quality, training, and
        service improvement purposes. Please do not share sensitive personal,
        payment, or confidential information through this tool.
      </p>
    </div>
  </div>
</div>
